<template>
    <div class="select-container" :class="{open: isOpen, nobor: border==false}" v-on-clickaway="away">
        <div class="select-input">
            <span class="fa fa-times-circle-o cross" v-if="!isDisabled && keyWord!=''" @click="onClear"></span>
            <input type="text" class="form-control form-control-sm"
                ref="input"
                :placeholder="place"
                v-model="keyWord"
                @focus="onFocus"
                @input="toList"
                :disabled="isDisabled"/>
        </div>
        <div class="select-dropdown vld-parent" ref="i100" style="min-height: 30px;">
            <table class="table-select">
                <tbody>
                    <tr v-for="(ret,index) in list" :key="index" @click="select(ret)">
                        <td>{{ret.Num}}</td>
                        <td>{{ret.Name}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { mixin as clickaway } from 'vue-clickaway';
    export default {
        mixins: [ clickaway ],
        props: {
            value: {
                type: String,
                default: ''
            },
            border: {
                type: Boolean,
                default: true
            },
            place: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            productType: {
                type: String,
                default: '0'
            }
        },
        data: function(){
            return {
                keyWord: this.value,
                productTypeId: this.productType,
                isOpen: false,
                list: [],
                isDisabled: this.disabled,
                isShow: false
            }
        },
        methods: {
            toList(){
                this.list = [];
                let loading = this.$loading.show({
                    container: this.$refs.i100,
                    height: 25,
                    loader: 'dots'
                });
                this.$api().post('item/0/list', { Text: this.keyWord, ProductTypeId: this.productTypeId }).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Json.Items;
                        this.isShow = true;
                    }
                }).finally(function(){ loading.hide(); });
            },
            onFocus(){
                this.isOpen = true;
                if(!this.isShow) this.toList();
            },
            away() {
                this.isOpen = false;
            },
            select(item){
                this.keyWord = item.Name;
                this.isOpen = false;
                this.$emit('select', item);
            },
            onClear(){
                this.keyWord = '';
                this.$refs.input.focus();
            }
        },
        watch: {
            value(val){
                this.keyWord = val;
            },
            disabled(value){
                this.isDisabled = value;
            }
        }
    }
</script>